import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import Table from '../../../../components/CustomTable';
import routes from '../../../../routes';

import { checkTablePermission } from '../../../../utils/route-auth';
import { options } from './constant';
import { getConfigurationDataAction, getPlatformListAction } from '../../../../actions';
import { withRouter } from "react-router-dom";
import { PERMISSION } from '../../../../constants/permission';


const Tabs = asyncRoute(() => import('../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class Variable extends Component {

  state = {
    variableList: [],
    optionsList: options,
    platformId: '',
  };

  componentWillMount() {

    let optionsList = checkTablePermission({ add: PERMISSION.ADMIN.VARIABLE.ADD, edit: PERMISSION.ADMIN.VARIABLE.EDIT, delete: PERMISSION.ADMIN.VARIABLE.DELETE }, cloneDeep(options));

    this.setState({ optionsList });

    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.this.props;
      history.push(routes.preSignIn);
    }
    this.getVariable();
  }

  async getVariable() {
    const { getConfigurationDataAction, getPlatformListAction, tenantId, authToken, userId } = this.props;

    let list = []
    let platformRes = await getPlatformListAction({ tenantId, authToken, userId });

    if (platformRes && platformRes.responseCode && platformRes.responseCode.status === "Success" && platformRes.responseList && platformRes.responseList.length) {
      list = platformRes.responseList.map(item => ({ id: item.id, text: item.name }))
    }

    let respone = await getConfigurationDataAction({ tenantId, authToken, userId });
    if (respone && respone.responseCode && respone.responseCode.status === "Success" && respone.responseList && respone.responseList.length) {
      let variableList = [];
      variableList = respone.responseList.map((item) => {
        item.platformName = (list || []).find(platform => platform.id == item.platformId);
        if (item.platformName && item.platformName.text) {
          item.platformName = item.platformName.text
        } else {
          item.platformName = ''
        }
        let attributeValues = [];
        if (item.attributeValues && item.attributeValues.length) {
          item.attributeValues.forEach((a) => {
            attributeValues.push(a.value);
          });

          item.attributeValuesListDetail = attributeValues;
          // item.attributeValuesList = attributeValues.toString();
        }
        return item;
      });
      this.setState({ variableList });
    }
  }

  handleAction = (row, action) => {
    const { match, history } = this.props;
    if (action.type === 'edit') {
      this.handleEdit(row, match, history);
    } else if (action.type === 'delete') {
      this.handleDelete(row, action);
    }
  };

  handleEdit(row, match, history) {
    history.push(`${match.path}/${routes.admin.variable.edit}/${row.aId}`);
  }

  async handleDelete(row) {
    // const { getConfigurationDataAction, deleteTenantAction, tenantId, authToken, userId } = this.props;
    // let { responeCode: { status } } = await deleteTenantAction(tenantId, authToken, userId, { id: row.tenantId });
    // if (status === 'Success') {
    //   getConfigurationDataAction(tenantId, authToken, userId);
    //   return
    // }
    console.log("In Valid Id");
  }

  render() {
    const { variableList, optionsList, platformId } = this.state;
    const { platformListAll } = this.props;

    let variableData = [];
    if (platformId) {
      if (variableList && variableList.length) {
        variableData = variableList.filter(item => item.platformId == platformId);
      }
    } else {
      variableData = variableList;
    }

    return (
      <div className="main-panel ion">
        <div className="content-wrapper">
          <BreadCrumb />
          <div className="row">
            <Card >
              <Tabs container="admin" />
              <div className="tab-pane fade show active"><br />
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Platform</label>
                      <div className="col-sm-9">
                        <select
                          name="platform"
                          className="form-control"
                          onChange={(e) => { this.setState({ platformId: e.target.value }) }}
                        >
                          <option value="">All Platform</option>
                          {
                            platformListAll && platformListAll.length ?
                              platformListAll.map((a, index) => (<option key={index} value={a.id}>{a.name}</option>))
                              : ''
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <Table
                    options={optionsList}
                    data={variableData}
                    handelAction={this.handleAction}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
    platformListAll: get(state, 'app.platformListAll.responseList', '')
  }), {
  getConfigurationDataAction,
  getPlatformListAction
}
)(Variable));

Variable.propTypes = {
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
  getConfigurationDataAction: PropTypes.func,
};
